import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from "@angular/forms";
import { DatePipe } from '@angular/common';

import { CommonmastersService } from "../commonmasters/commonmasters.service";
import { SavingsService } from "./shared/savings.service";

import { ConfirmationdialogService } from "../utility/shared/confirmationdialog.service";
import { ToasterserviceService } from "../utility/shared/toasterservice.service";
import { IndividualConfig, ToastrService } from 'ngx-toastr';
import { Toastpayload } from "../utility/shared/toastpayload";

@Component({
  selector: 'app-savings',
  templateUrl: './savings.component.html',
  styleUrls: ['./savings.component.css']
})

export class SavingsComponent implements OnInit {

  SavingsNo: number = 0;
  ErrorText: string;
  AddButtonText: string;
  Address :string;
  InterestRate: string;
  Maturity : string;
  readonlyTextBox: boolean = false;

  CustomerList: [''];
  AgentList: [''];
  PaymentTypeList: [''];
  SchemeList: any[]=[];
  RelationList: [''];
  DepositTypeList: [''];
  BankList: [''];
  RedeptionTypeList: [''];
  AreaList: [''];
  toast: Toastpayload;

  constructor(public savingsService: SavingsService,
    private commonmastersService: CommonmastersService,
    private router: Router, private route: ActivatedRoute,
    private datePipe: DatePipe,
    private toasterserviceService: ToasterserviceService,
    private confirmationdialogService: ConfirmationdialogService,)
    { }

  ngOnInit() {

    this.route.params.subscribe(params => {
      this.SavingsNo = +  params['Id'];  // (+) converts string 'id' to a number
    });

    this.GetDepositTypeList();
    this.GetAreaList();
    this.GetAgentList();
    this.GetPaymentTypeList();
    this.GetBankList();
    this.GetCustomerList();
    this.GetSchemeList();
    this.GetRelationsList();
    this.GetRedeptionTypeList();

    this.resetForm();
    this.GetAutogeneratedNumber();

    if (Number.isNaN(this.SavingsNo)) {
      this.savingsService.selectedSavings.Id = 0;
      this.savingsService.selectedSavings.Flag = 1;
      this.savingsService.selectedSavings.IsActive = true;
      this.AddButtonText = "Save";
    }
    else {
      this.savingsService.selectedSavings.Id = +this.SavingsNo;
      this.savingsService.selectedSavings.Flag = 2;
      this.savingsService.selectedSavings.IsActive = true;
      this.readonlyTextBox = true;
      this.AddButtonText = "Edit & Save";

      this.GetSavingsBySavingsNo();
    }

  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.savingsService.selectedSavings = {
      Id: 0,
      ApplicationNo: 0,
      DepositTypeId: 1,
      CustomerId: 0,
      CustomerName: null,
      Address: null,
      PanNo: null,
      Category: null,
      InterestRate: 0,
      MaturityDate: null,
      InterestPayementType: null,
      JointCustomers: null,
      DepositDate:  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"],
      DepositAmount: null,
      SchemeId: 0,
      NomineeName: null,
      NomineeRelationId: 0,
      NomineeDOB: null,
      RedemptionTypeId: 0,
      AreaId: 0,
      AgentId: 0,
      AgentName: null,
      Instructions: null,
      BankAccNo: null,
      BankName: null,
      BankBranch: null,
      IFSCCode: null,
      PaymentTypeId: 0,
      PaymentBankId: 0,
      ChequeNo: null,
      IsJoint: null,
      Remarks: null,
      EmployeeId: null,
      EmployeeBranchId: null,
      CompanyId: null,
      SaasId: null,
      IsActive: true,
      CreatedDate: null,
      ModifiedDate: null,
      Flag: 0,

      IsCustomerSearch: true,
      PreSavingsAmount :null,
      BranchId:0,

      ReportName: null,
      ToDate : null,
      CentreId: 0,
      IsOpening:false,
    }
  }

  onSubmit(form: NgForm) {

    console.log(this.savingsService.selectedSavings);
    if (this.savingsService.selectedSavings.CustomerId != null) {
    
      // if(this.savingsService.selectedSavings.Flag == 1){
          this.savingsService.IUDSavings(this.savingsService.selectedSavings)
          .toPromise()
          .then(data => {
            // this.resetForm(form);
            // this.savingsService.FetchSavingsList();
            this.router.navigate(['/savingslist']);
          })
      // }
      // else{
      //     this.DeleteMessage();
      // } 
    }
    
  }

  GetSavingsBySavingsNo() {
    if (this.savingsService.selectedSavings.Id !== 0) {
      // this.loanService.selectedLoan.Id =+ this.loanService.selectedLoan.Id;
      this.savingsService.FetchSavingsById(this.savingsService.selectedSavings).subscribe(data => {

        this.savingsService.selectedSavings = data;
        this.savingsService.selectedSavings.Flag = 2;

        this.Address = data.Address;
        this.InterestRate = this.SchemeList[0].InterestPrecentage;
        let numWeeks = this.SchemeList[0].SavingTypePeriod;
        // this.Maturity =  data.MaturityDate;
        this.savingsService.selectedSavings.NomineeDOB = data.NomineeDOB == '0001-01-01T00:00:00' ?  this.CurrentDateFormatted(new Date(Date.now())) : data.NomineeDOB;
        this.Maturity =  this.datePipe.transform(new Date(Date.now()  + (50 * 6.048e+8)), 'dd/MM/yyyy').toString();
        this.savingsService.selectedSavings.MaturityDate = new Date(Date.now()  + (numWeeks * 6.048e+8));
        this.savingsService.selectedSavings.ModifiedDate = new Date(Date.now());
      })
    }
  }

  GetAutogeneratedNumber(): any {
    if (this.savingsService.selectedSavings.Id === 0) { // Parent Loan No number checks
      const myAutoGeneratedId = this.commonmastersService.FetchAutogeneratedNumber()
        .toPromise()
        .then(res => {
          this.savingsService.selectedSavings.ApplicationNo = res[0].AutoGeneratedId;
          return Promise.resolve(res[0].AutoGeneratedId);
        })
        .catch(err => { console.log(err) });
    }
    else {
      this.savingsService.selectedSavings.ApplicationNo = + this.SavingsNo;
    }
  }

  GetCustomerList() {
    this.savingsService.FetchCustomerList().subscribe(data => {
      this.CustomerList = data;      
    })
  }

  GetAgentList() {
    this.commonmastersService.FetchAgentList().subscribe(data => {
      this.AgentList = data;
    })
  }

  GetPaymentTypeList() {
    this.commonmastersService.FetchPaymentMode().subscribe(data => {
      this.PaymentTypeList = data;
    })
  }

  GetSchemeList() {
    // this.commonmastersService.FetchScheme().subscribe(data => {
    //   this.SchemeList = data;
    // })
    this.savingsService.FetchSavingsSchemeList().subscribe(data => {
      this.SchemeList = data;
    })
  }

  GetRelationsList() {
    this.commonmastersService.GetRelationList().subscribe(data => {
      this.RelationList = data;
    })
  }

  GetAreaList() {
    this.commonmastersService.FetchAreaList().subscribe(data => {
      this.AreaList = data;
    })
  }

  GetDepositTypeList() {
    this.commonmastersService.FetchDepositTypeList().subscribe(data => {
      this.DepositTypeList = data;
    })
  }

  GetBankList() {
    this.commonmastersService.FetchBankList().subscribe(data => {
      this.BankList = data;
    })
  }

  GetRedeptionTypeList() {
    this.commonmastersService.FetchRedeptionTypeList().subscribe(data => {
      this.RedeptionTypeList = data;
    })
  }

  selectChange($event:Event){
      //  this.GetCustomerAddressById(this.loanService.selectedLoan.CustomerId);
      this.Address =$event["Address"];
      
      }

  SelectSchemeChange(id: any):void{
   
    this.InterestRate = this.SchemeList[0].InterestPrecentage;
    let numWeeks = this.SchemeList[0].SavingTypePeriod;
    // this.Maturity = new Date(Date.now()  + (numWeeks * 7));
    this.Maturity =  this.datePipe.transform(new Date(Date.now()  + (numWeeks * 6.048e+8)), 'dd/MM/yyyy').toString();
    this.savingsService.selectedSavings.MaturityDate = new Date(Date.now()  + (numWeeks * 6.048e+8));
  }
  
  CurrentDateFormatted(paramDate: Date)
  {

   return this.datePipe.transform(new Date(paramDate), 'yyyy-MM-dd').toString()
  }

  DeleteMessage():any{

    if(this.savingsService.selectedSavings.Flag == 2){
      
      this.toast = {
        message: "The savings have been edited",
        title: 'Edit case',
        ic: {
          timeOut: 3000,
          closeButton: true,
        } as IndividualConfig,
        type: 'success',
      };
  
      let title: string = "Confirmation";
      let message: string = "If you continue, You can change the deposit date. Are you sure? ";
      let btnOkText: string = "Yes";
      let btnCancelText: string = 'No, Exit';

      this.confirmationdialogService.openModalWithClass(title, message, btnOkText, btnCancelText)
      .subscribe(confirmed => {
        if (confirmed == true) {

        }
      else {
        this.toast.message = 'You are cancelled the default case deletion.!'
        this.toast.type = 'warning';
        this.toasterserviceService.showToast(this.toast);
      }
    });
  }

  }

}


